import { customerv6Url } from '../api-urls';

export function requestGetCustomerByIdRequest({ customerId, customerToken }) {
  return {
    url: `${customerv6Url}/${customerId}`,
    method: 'get',
    headers: {
      'access-token': customerToken
    }
  };
}
